var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1Dark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 6.66675H3.33366C2.41449 6.66675 1.66699 7.41425 1.66699 8.33341V16.6667C1.66699 17.5859 2.41449 18.3334 3.33366 18.3334H11.667C12.5862 18.3334 13.3337 17.5859 13.3337 16.6667V8.33341C13.3337 7.41425 12.5862 6.66675 11.667 6.66675Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 1.66675H8.33366C7.89163 1.66675 7.46771 1.84234 7.15515 2.1549C6.84259 2.46746 6.66699 2.89139 6.66699 3.33341V5.00008H13.3337C13.7757 5.00008 14.1996 5.17568 14.5122 5.48824C14.8247 5.8008 15.0003 6.22472 15.0003 6.66675V13.3334H16.667C17.109 13.3334 17.5329 13.1578 17.8455 12.8453C18.1581 12.5327 18.3337 12.1088 18.3337 11.6667V3.33341C18.3337 2.89139 18.1581 2.46746 17.8455 2.1549C17.5329 1.84234 17.109 1.66675 16.667 1.66675Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1Dark);
export default __webpack_public_path__ + "static/media/1Dark.271d74a3ec57685c11032e9e55af854e.svg";
export { ForwardRef as ReactComponent };